import { useState } from 'react';
import {
  DialogContentText,
  Box,
  TextField,
  IconButton,
} from '@material-ui/core';
import { useAllowedDomains } from '../hooks/useAllowedDomain';
import Stack from '@mui/material/Stack';

import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import { Table } from '@backstage/core-components';
import Autocomplete from '@mui/material/Autocomplete';

export const REQUIRED_DOMAIN_PATTERNS = [
  'principalaws.systems',
  'principalazure.systems',
];

export const isRequiredDomain = (domain: string): boolean =>
  REQUIRED_DOMAIN_PATTERNS.some(pattern => domain.includes(pattern));

interface DnsForwarderEditDialogProps {
  tempDomains: string[];
  setTempDomains: React.Dispatch<React.SetStateAction<string[]>>;
}

export const DnsForwarderEditDialog = ({
  tempDomains,
  setTempDomains,
}: DnsForwarderEditDialogProps) => {
  const { allowedDomains } = useAllowedDomains();
  const [selectedDomain, setSelectedDomain] = useState<string | null>(null);

  const handleRemove = (domain: any) => {
    setTempDomains(tempDomains.filter(domainKey => domainKey !== domain));
  };

  const handleAdd = () => {
    if (selectedDomain) {
      setTempDomains([...tempDomains, selectedDomain]);
      setSelectedDomain(null);
    }
  };

  const columns = [{ title: 'Domains', field: 'key', width: 'fullWidth' }];

  return (
    <Box style={{ maxWidth: '600px', margin: '0 auto' }}>
      <Stack spacing={2} width="100%">
        <DialogContentText>
          To enable additional domains for internal DNS resolution, please use
          the dropdown to select and add. If you want to remove any you can do
          so by clicking the delete icon.
        </DialogContentText>
        <Stack direction="row" spacing={1} alignItems="center">
          <Box flexGrow={1}>
            <Autocomplete
              options={allowedDomains.filter(
                domain => !tempDomains.includes(domain),
              )}
              renderInput={params => <TextField {...params} />}
              value={selectedDomain || ''}
              onChange={(_event: any, newValue: string | null) => {
                setSelectedDomain(newValue);
              }}
            />
          </Box>
          <Box>
            <IconButton
              color="primary"
              onClick={handleAdd}
              disabled={!selectedDomain}
            >
              <AddIcon />
            </IconButton>
          </Box>
        </Stack>
        <Table
          columns={columns}
          data={tempDomains.map(domainName => ({
            key: domainName,
          }))}
          options={{
            search: false,
            header: false,
            padding: 'dense',
            pageSize: 10,
            toolbar: false,
            paging: tempDomains.length > 10,
          }}
          actions={[
            row => ({
              icon: () => <DeleteIcon />,
              tooltip: 'Remove Domain',
              onClick: (_event, rowData) => handleRemove((rowData as any).key),
              hidden: isRequiredDomain((row as any).key),
            }),
          ]}
        />
      </Stack>
    </Box>
  );
};
